import React, { FC } from "react";
import "./ItemStore.css";
import { ReactComponent as Clock } from "assets/icons/clock.svg";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

interface ItemListaCategoriasProps {
  nome: string;
  imagemUrl: string;
  id: string;
  onClick?: () => void;
  isClosed?: boolean;
}

export const ItemStore: FC<ItemListaCategoriasProps> = (props) => {
  const { resolution } = useScreenStore();

  return (
    <div onClick={props.onClick} className="itemListaStore">
      <div
        className="imagem"
        style={{
          backgroundImage: "url(" + props.imagemUrl + ")",
          opacity: props.isClosed ? 0.5 : undefined,
          minWidth: resolution === ResolutionType.FULL_HD ? 300 : 250,
          height: resolution === ResolutionType.FULL_HD ? 250 : 180,
        }}
      ></div>
      {props.isClosed && (
        <div className="closed">
          <Clock style={{ width: 25, marginRight: 8 }} />
          Loja fechada
        </div>
      )}
      <div
        className="nome"
        style={{
          fontSize: resolution === ResolutionType.FULL_HD ? 28 : 22,
        }}
      >
        {props.nome}
      </div>
    </div>
  );
};
